import { isNil } from 'lodash';
import { HINDSIGHTING_CONTEXT } from './Constants';

export const IS_HINDSIGHTING = (str?: string) => {
  if (isNil(str)) {
    // rather than error just fail check
    return false;
  }

  return str.localeCompare(HINDSIGHTING_CONTEXT, undefined, { sensitivity: 'base' }) === 0;
};
